<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Seamless Payment Solutions for E-Commerce: Powering Your Success</div>
            <div class="banner_tips mt-40 fw-300">Unlock the full potential of your online store with our cutting-edge payment platform. Designed to prioritize speed, simplicity, and scalability, we help your business thrive in the fast-paced world of e-commerce.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Pay Out Using Your Pay-In Balance</div>
                <div class="title_tag color6">Maximize efficiency by using your existing pay-in balance for payouts, reducing costs and cash flow gaps.</div>
            </div>
          <div class="py-20" v-for="item in list1" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap no_col_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center bg_9 p-20" :class="[item.id%2==0?'order-2':'']">
                
                    <div class="tab_left text-l p-20" >
                         <img :src="item.tab" alt="" class="w-48px h-48px mb-10" >
                        <div class="half_title color2">{{ item.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Our E-Commerce Advantage</div>
                <div class="title_tag color6">As a leading global payment platform and open banking provider, we empower your business with innovative solutions. Our AI-driven technology and machine-learning insights deliver:</div>
            </div>
          <div class="py-20" v-for="item in list2" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap no_col_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 bg_9 flex_center" :class="[item.id%2==0?'order-2':'']">
                    <div class="tab_left text-l p-20" >
                         <img :src="item.tab" alt="" class="w-48px h-48px mb-10" >
                        <div class="half_title color2">{{ item.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
          <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>
                
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How quickly can I start processing payments?" name="1">
                            <div class="coll_item">With our streamlined onboarding and plug-and-play APIs, you can be up and running in hours.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is your platform secure?" name="2">
                           <div class="coll_item">Absolutely. We use advanced encryption and AI-powered fraud detection to protect every transaction.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I use your platform for international sales?" name="3">
                           <div class="coll_item">Yes! Our network connects with leading banks worldwide, ensuring smooth cross-border payments.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t21.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Transform Your E-Commerce Business</div>
                        <div class="title_tag color6 text-l">Experience the power of instant payments, seamless integrations, and actionable insights. Our platform is built to simplify operations and accelerate your growth, so you can focus on what matters most—your customers.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import icon1 from '../../assets/image/t14.png'
import icon2 from '../../assets/image/t15.png'
import icon3 from '../../assets/image/t16.png'


import icon5 from '../../assets/image/t17.png'
import icon6 from '../../assets/image/t18.png'
import icon7 from '../../assets/image/t19.png'



import tab1 from '../../assets/image/tb22.png'
import tab2 from '../../assets/image/tb23.png'
import tab3 from '../../assets/image/tb24.png'
import tab4 from '../../assets/image/tb25.png'
import tab5 from '../../assets/image/tb26.png'
import tab6 from '../../assets/image/tb27.png'
export default {
    data(){
        return{
            list1:[
                {title:'Flexible Growth Plans',msg:"From startups to global enterprises, our customizable plans scale with your business, ensuring you have the tools to succeed at every stage.",img:icon1,id:1,tab:tab1},
                {title:'Lightning-Fast Transactions',msg:"Process payments instantly, with funds available in your account in minutes, so you can focus on delighting your customers.",img:icon2,id:2,tab:tab2},
                {title:'Global Reach, Local Expertise',msg:"Connect effortlessly with major banks across the UK, EU, and beyond, enabling smooth and secure transactions worldwide.",img:icon3,id:3,tab:tab3},
              
            ],
            list2:[
                {title:'Smart Transaction Management',msg:"Streamline payments with real-time analytics and fraud detection.",img:icon5,id:5,tab:tab4},
                {title:'Open Banking Innovation',msg:"Leverage secure data-sharing with trusted banks for faster, more reliable transactions.",img:icon6,id:6,tab:tab5},
                {title:'Effortless Integration',msg:"Our intuitive APIs make it simple to bring your products to market and enhance customer experiences.",img:icon7,id:7,tab:tab6},
             
                
            
            ],
            
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg3.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.no_col_gap{
    grid-column-gap:0!important;
}
</style>